/**
 * Which week the drill-down opens on when the URL carries no `?week=`.
 * ISSUE-950 R8 and D8.
 *
 * Deliberately NOT a copy of landingDay.ts. That rule prefers the nearest
 * FUTURE day with games (landingDay.ts:26) before falling back to the last
 * past one. R8 and D8 both say the week in progress, or the most recent week
 * with games when the league is between weeks, so a fan in a bye gap lands on
 * the week just played rather than the one about to start. That difference is
 * the requirement, not a bug. Do not "fix" it back to the day rule.
 */
import type { typeSeasonWeek } from "./seasonWeek";

/** In order:
 *    1. the week in progress, firstDay <= today <= lastDay
 *    2. otherwise the most recent week that has already finished
 *    3. otherwise the earliest week, so a season that has not started yet
 *       opens on Week 1 instead of on nothing
 *  Returns null only when the league has no weeks with games at all. */
export function resolveLandingWeek(input: {
  todayDay: string;
  /** From POST /event/weeks-with-games-list. Any order; sorted internally. */
  weeks: readonly typeSeasonWeek[];
}): number | null {
  const sorted = [...input.weeks].sort((a, b) => a.seasonWeek - b.seasonWeek);

  const inProgress = sorted.find(
    (week) => week.firstDay <= input.todayDay && input.todayDay <= week.lastDay,
  );
  if (inProgress !== undefined) {
    return inProgress.seasonWeek;
  }

  const finished = sorted.filter((week) => week.lastDay < input.todayDay);
  const mostRecent = finished[finished.length - 1];
  if (mostRecent !== undefined) {
    return mostRecent.seasonWeek;
  }

  return sorted[0]?.seasonWeek ?? null;
}
